import styled from 'styled-components';
import { Checkbox } from 'ui/checkbox';
import { Link } from 'ui/links';
import { Body2 } from 'ui/theme';
import { FormField } from 'ui/formField';
import { CheckboxField } from 'lib/iterable-hook-form';

export const TrialPeriodDescription = styled(Body2)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  cursor: pointer;
  grid-area: description;
`;

export const TrialEndDateFormField = styled(FormField)`
  grid-area: endDateField;
`;

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing.utils.pxToRem(18)} 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas: 'checkbox description' '. endDateField';
  gap: 10px;
`;

export const CheckboxWithMarginTop = styled(Checkbox)`
  margin-top: 5px;
`;

export const CheckboxFieldWithMarginTop = styled(CheckboxField)`
  margin-top: 2.5px;
`;

export const LightBody2 = styled(Body2)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const LightBody2WithPointer = styled(LightBody2)`
  cursor: pointer;
`;

export const LinkSmallText = styled(Link)`
  font-size: inherit;
`;
